import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { QuestionsV3, QuestionV3ControlTypes } from '../../classes/enum';

@Component({
  selector: 'bepatient-question-v3',
  templateUrl: './dynamic-form-question.component.html',
  standalone: false
})
export class DynamicFormQuestionComponentV3 {
  @Input() color: string;
  @Input() question: QuestionsV3;
  @Input() formGroup: UntypedFormGroup;
  @Input() readonly: Boolean;
  @Input() isLoadingForm: boolean;

  questionControlTypes = QuestionV3ControlTypes;

  get isValid(): boolean {
    return this.formGroup.controls[this.question.key].valid;
  }
}
